import React, { useEffect, useRef } from 'react';

const ModalSoborno = ({ open, onClose, onConfirm }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-3 sm:static sm:z-auto sm:bg-transparent sm:p-0 sm:w-full sm:justify-center sm:mb-2">
      <div ref={modalRef} className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-5 sm:p-6 w-full max-w-xs flex flex-col items-center animate-fade-in border border-gray-200 dark:border-gray-700">
        <h2 className="text-base font-bold mb-4 text-center dark:text-white">¿Has sobornado al presentador?</h2>
        <div className="flex w-full gap-3 sm:gap-4 mt-2">
          <button
            className="flex-1 bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-colors"
            onClick={() => { onConfirm(); }}
          >
            Sí
          </button>
          <button
            className="flex-1 bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded transition-colors"
            onClick={onClose}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalSoborno;
